export { default } from './InlinePageSection';
